import { render, staticRenderFns } from "./wenhua.vue?vue&type=template&id=16ba4e1a"
import script from "./wenhua.vue?vue&type=script&lang=js"
export * from "./wenhua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports